import React, { useState } from "react";
import "./styles.css";
import BaseModal from "../BaseModal";
import sampleImage from "../../../../Assets/Images/doctorProfile.png";

const ShareModal = ({ onClose }) => {
  const [flyer, setFlyer] = useState(false);
  const closeFlyer = () => {
    setFlyer(false);
    onClose();
  };
  const doctors = [
    {
      name: "Dr. Shikha Singh",
    },
    {
      name: "Dr. Ritu Dave",
    },
  ];
  return (
    <BaseModal
      title="Share Profile"
      onClose={onClose}
      showFlyerMessage={flyer}
      flyerMessageText="Profile has been shared Successfully"
      onFlyerMessageClose={() => closeFlyer()}
    >
      {doctors.map((doc) => {
        return (
          <div className="doc-list">
            <div
              className="doc-list-item"
              onClick={() => {
                setFlyer(true);
              }}
            >
              <img
                src={sampleImage}
                alt="img"
                style={{ width: "40px", height: "40px" }}
              />
              <span>{doc.name}</span>
            </div>
          </div>
        );
      })}
    </BaseModal>
  );
};

export default ShareModal;
